import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const { user } = useAuth();

    // Initialize from localStorage, user profile, or system preference
    const [theme, setTheme] = useState(() => {
        if (typeof window !== 'undefined' && window.localStorage) {
            const stored = localStorage.getItem('theme');
            if (stored) return stored;
        }
        return 'system';
    });

    // Sincronización Real con Perfil de Usuario
    useEffect(() => {
        if (user?.theme && user.theme !== theme) {
            setTheme(user.theme);
        }
    }, [user?.theme]);

    useEffect(() => {
        const root = window.document.documentElement;
        // ... rest of logic stays same (omitting repeat for brevity but ensures logic integrity)
        const removeOldTheme = () => {
            root.classList.remove('light', 'dark');
        };

        const applySystemTheme = () => {
            const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            removeOldTheme();
            root.classList.add(systemTheme);
        };

        if (theme === 'system') {
            applySystemTheme();
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            const handleChange = () => applySystemTheme();
            mediaQuery.addEventListener('change', handleChange);
            return () => mediaQuery.removeEventListener('change', handleChange);
        } else {
            removeOldTheme();
            root.classList.add(theme);
        }

        localStorage.setItem('theme', theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
